module.exports = __webpack_public_path__ + "img/Flag_of_Norway (1).d34123ac.svg";